import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { WarningsFlexible } from '../../components/WarningsFlexible';
import { trackClickComplaint } from '../../components/bottom_control_panel/tracking';
import { IState } from '../../store';
import { EFeedbackComplaint, statusChanger } from '../../store/complaint/feedback_complaint';

export const WarningsFlexibleContainer = () => {
  const agent = useSelector((state: IState) => state.offerData.agent);
  const offer = useSelector((state: IState) => state.offerData.offer);
  const warningMessage = useSelector((state: IState) => state.offerData.offer.moderationInfo?.warningMessage);
  const dispatch = useDispatch();
  const complaintFeedbackFormStatus = (status: EFeedbackComplaint) => dispatch(statusChanger(status));
  const [isComplaintVisible, setIsComplaintVisible] = React.useState<boolean>(false);
  const toggleComplaintPopup = React.useCallback(() => {
    if (isComplaintVisible) {
      complaintFeedbackFormStatus(EFeedbackComplaint.default);
    } else {
      trackClickComplaint(offer, agent);
    }

    setIsComplaintVisible(!isComplaintVisible);
  }, [isComplaintVisible, offer, agent]);

  if (!warningMessage) {
    return null;
  }

  const props = {
    warningMessage,
    toggleComplaintPopup,
    isComplaintVisible,
  };

  return <WarningsFlexible {...props} />;
};
